import React from 'react'
import ScrollAnimation from 'react-animate-on-scroll';
import ReactGA from 'react-ga'
import '../../css/rahul-styles.css'

const InstitutionsBannerSection = (props) => {

    const {country, bannerUrl, altDescription} = props

    return (
        <div className="container">
            <div className="row institute-banner-row align-items-center">
                <div className="col-md-6 mb-5">
                    <ScrollAnimation 
                        animateIn='fadeInLeft'
                        style = {{'animation-duration': '1s'}}
                    > 
                        <div class="text-box  wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".1s">
                            <h2 className="institute-banner-heading">Pursue your passions at {country} best universities</h2>
                            <p className="institute-banner-sub-heading">The WorldGrad has collaborated with top global institutions to bring the latest programs to students</p>
                            <a 
                                class="btn-default institute-banner-button" 
                                onClick={() => { 
                                this.scrollToSection() 
                                ReactGA.event({
                                    category: "Home Page",
                                    action: "Clicks",
                                    label: "Our Partner Institutions"
                                })
                            }} href="#">OUR PARTNER Institutions</a>
                        </div> 
                    </ScrollAnimation>
                </div>
                <div className="col-md-6 institute-page-image-container">
                    <img 
                        className="institute-banner-img"
                        src={bannerUrl} 
                        alt={altDescription} 
                    />
                    <img 
                        className="institute-banner-student1" 
                        src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/1-svg-N.png" 
                        alt="Student-1" 
                    />
                    <img 
                        className="institute-banner-student4" 
                        src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/4-svg-m.png" 
                        alt="Student-2" 
                    />
                    <img 
                        className="institute-banner-student2" 
                        src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/2-svg-s.png" 
                        alt="Student-3" 
                    />
                    <img 
                        className="institute-banner-student3" 
                        src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/3-svg-T.png" 
                        alt="Student-4" 
                    />
                    <img 
                        className="institute-banner-top-dotted" 
                        src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/toppng.com-dot-pattern-png-monochrome-547x547.png" 
                        alt="Dotted-Design" 
                    />
                    <img 
                        className="institute-banner-bottom-dotted"  
                        src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/toppng.com-dot-pattern-png-monochrome-547x547-copy.png" 
                        alt="Dotted-Design" 
                    />
                </div>
            </div>
        </div>
    )
}

export default InstitutionsBannerSection
